module.exports = __webpack_public_path__ + "img/373.d723c766.jpg";